import React from 'react';
import { ArrowLeft } from 'lucide-react';
import styles from './NotFound.module.css';
import Button from '../../components/Button/Button';
import Seo from '../../components/Seo/Seo';

export default function NotFound() {
    return (
        <section className={styles.page}>
            <Seo title="Page not found" noindex />
            <span className={styles.code}>404</span>
            <h1>This page is not here</h1>
            <p>The link may be old or mistyped. Head back to the home page to find what you need.</p>
            <Button to="/" icon={ArrowLeft}>Back to home</Button>
        </section>
    );
}
